"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYLIST_IMAGES_COUNT = void 0;
const ModelStatus_1 = require("../types/ModelStatus");
const notInitialized_1 = require("../utils/notInitialized");
exports.PLAYLIST_IMAGES_COUNT = 8;
class PlaylistsModel {
    constructor() {
        this.playlists = [];
        this.status = ModelStatus_1.ModelStatus.Pending;
        this.onChange = notInitialized_1.notInitialized;
    }
    removeTrack(playlistId, trackId) {
        const playlist = this.get(playlistId);
        playlist.songs = playlist.songs.filter((song) => song.id !== trackId);
    }
    get(id) {
        const playlist = this.playlists.filter((playlist) => playlist.id === id)[0];
        if (!playlist) {
            throw new Error(`Playlist with id: ${id} not found`);
        }
        return playlist;
    }
    update(id, newPlaylist) {
        const index = this.playlists.findIndex((playlist) => playlist.id === id);
        this.playlists[index] = newPlaylist;
    }
    updateTrack(track) {
        for (const playlist of this.playlists) {
            const index = playlist.songs.findIndex((song) => song.id === track.id);
            playlist.songs[index] = track;
        }
    }
    getFilteredForAddition(trackId) {
        return this.playlists.filter((playlist) => {
            return playlist.songs.filter((song) => song.id === trackId).length === 0;
        });
    }
    add(newPlaylist) {
        this.playlists.push(newPlaylist);
    }
    delete(id) {
        this.playlists = this.playlists.filter((playlist) => playlist.id !== id);
    }
}
exports.default = PlaylistsModel;
